import { createAction, props } from '@ngrx/store';
import { Perfil, CreatePerfilRequest, UpdatePerfilRequest } from '../models/perfil.interface';

// Load Perfiles
export const loadPerfiles = createAction('[Perfil] Load Perfiles');

export const loadPerfilesSuccess = createAction(
  '[Perfil] Load Perfiles Success',
  props<{ perfiles: Perfil[] }>()
);

export const loadPerfilesFailure = createAction(
  '[Perfil] Load Perfiles Failure',
  props<{ error: string }>()
);

// Create Perfil
export const createPerfil = createAction(
  '[Perfil] Create Perfil',
  props<{ perfil: CreatePerfilRequest }>()
);

export const createPerfilSuccess = createAction(
  '[Perfil] Create Perfil Success',
  props<{ perfil: Perfil }>()
);

export const createPerfilFailure = createAction(
  '[Perfil] Create Perfil Failure',
  props<{ error: string }>()
);

// Update Perfil
export const updatePerfil = createAction(
  '[Perfil] Update Perfil',
  props<{ id: number; perfil: UpdatePerfilRequest }>()
);

export const updatePerfilSuccess = createAction(
  '[Perfil] Update Perfil Success',
  props<{ perfil: Perfil }>()
);

export const updatePerfilFailure = createAction(
  '[Perfil] Update Perfil Failure',
  props<{ error: string }>()
);

// Delete Perfil
export const deletePerfil = createAction('[Perfil] Delete Perfil', props<{ id: number }>());

export const deletePerfilSuccess = createAction(
  '[Perfil] Delete Perfil Success',
  props<{ id: number }>()
);

export const deletePerfilFailure = createAction(
  '[Perfil] Delete Perfil Failure',
  props<{ error: string }>()
);

// Search Perfiles
export const searchPerfiles = createAction('[Perfil] Search Perfiles', props<{ query: string }>());

export const searchPerfilesSuccess = createAction(
  '[Perfil] Search Perfiles Success',
  props<{ results: Perfil[] }>()
);

export const clearPerfilSearch = createAction('[Perfil] Clear Search');

// Select Perfil
export const selectPerfil = createAction(
  '[Perfil] Select Perfil',
  props<{ perfil: Perfil | null }>()
);

// Clear Error
export const clearPerfilError = createAction('[Perfil] Clear Error');
